import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { useQuery } from '../../utils/helpers';
import DataDeletionRequest from '../../pages/user-data-deletion';
import DataDeletionConfirm from '../../pages/user-data-deletion/confirm';

export default function DataDeletionRoutes() {
  const query = useQuery();
  const token = query.get('token') ?? '';

  return (
    <Route
      render={({ location }) => (
        <Switch location={location}>
          <Route
            exact
            path="/user-data-deletion/confirm"
            render={() => <DataDeletionConfirm token={token} />}
          />
          <Route
            exact
            path="/user-data-deletion"
            component={DataDeletionRequest}
          />
        </Switch>
      )}
    />
  );
}
